import { IBaseComponentProps } from '@actr/specs/src/base-component-props';
import { ButtonSizes, ButtonTypes } from '@actr/ui/src/components/_atoms/button/specs';
import { Button as ButtonRecipe, ButtonText } from '@actr/ui/src/components/_atoms/button/style.css';
import { Text } from '@actr/ui/src/components/_atoms/text';
import classNames from 'classnames';
import React, {
  FC,
  memo,
  useMemo
} from 'react';

import ChannelDecoratedLink from '@/ui/channel-decorated-link';

import * as Styled from './style.css';

export interface SeoButtonProps extends IBaseComponentProps {
  /** Цветовая схема кнопки
   * @default ButtonTypes.BRAND
   */
  buttonType?: ButtonTypes;
  /** Размер кнопки
   * @default ButtonSizes.M
   */
  size?: ButtonSizes;
  /** Растянуть кнопку на 100% */
  fullWidth?: boolean;
  /** url для перехода */
  url: string;
}

/**
 * семмантически корректная кнопка для SEO через <a>
 * */
const SeoButton: FC<SeoButtonProps> = props => {
  const {
    className,
    buttonType = ButtonTypes.BRAND,
    size = ButtonSizes.S,
    fullWidth,
    children,
    url
  } = props;

  const themeFontName = useMemo(() => {
    switch (size) {
      case ButtonSizes.L: return 'paragraph.xl.bold';
      case ButtonSizes.M: return 'paragraph.m.semi';
      default: return 'paragraph.s.semi';
    }
  }, [size]);

  return (
    <ChannelDecoratedLink
      href={url}
      className={classNames(ButtonRecipe({ buttonType, size, fullWidth }), Styled.SeoButton, className)}>
      {
          children && (
            <Text className={ButtonText} font={themeFontName}>
              {children}
            </Text>
          )
        }
    </ChannelDecoratedLink>
  );
};

export default memo(SeoButton);
